import React from "react";
import { SkipNavLink, SkipNavContent } from "@reach/skip-nav";
import "@reach/skip-nav/styles.css";
import { Helmet } from "react-helmet";
import FooterEmailSignUpForm from "../components/Forms/FooterEmailSignUpForm";

import "../styles/global.scss";

import Header from "./Header";
import Footer from "./Footer";
// import EcommForumModal from "./EcommForumModal";

const Layout = ({ children }) => {
	return (
		<>
			<Helmet>
				<script
					src="https://cdn.embedly.com/widgets/platform.js"
					type="text/javascript"
				/>
			</Helmet>
			<div className="site-overlay"></div>
			<SkipNavLink contentId="skip-to-content" />
			<Header />
			<SkipNavContent id="skip-to-content">
				<main>{children}</main>
			</SkipNavContent>
			<FooterEmailSignUpForm />
			<Footer />
			{/* <EcommForumModal /> */}
		</>
	);
};

export default Layout;
